import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';

const TimeCardEntry = ({ cardEntry }) => {
  const entryDate = moment(cardEntry.entryDate).format('ddd, MMM Do, YYYY');
  const localTimeIn = moment(cardEntry.timeIn).format('LT');
  const localTimeOut = moment(cardEntry.timeOut).format('LT');
  return (
    <tr>
      <td>
        <Link to={'/time-card-entries/' + cardEntry.id}>{entryDate}</Link>
      </td>
      <td>{cardEntry.entryType}</td>
      <td>{localTimeIn}</td>
      <td>{localTimeOut}</td>
      <td>{Number(cardEntry.entryHours).toFixed(2)}</td>
    </tr>
  );
};

TimeCardEntry.propTypes = {
  cardEntry: PropTypes.object.isRequired,
};

export default TimeCardEntry;



// WEBPACK FOOTER //
// ./src/components/timecard/TimeCardEntry.js